import Vue from 'vue';
import Vuex from 'vuex';
import {API} from '@/assets/ts/api';
import { resolve } from 'url';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pending: false,
    user: JSON.parse(localStorage.getItem('user') || '{}'),
    refeshToken: localStorage.getItem('refresh-token') || '',
    session: {
      authToken: localStorage.getItem('auth-token') || '',
      status: '',
      previousRoute: '',
    },
  },
  getters: {
    isLoggedIn: (state) => {
      return !!state.refeshToken;
    },
    user: (state) => {
      return state.user;
    },
    isPending: (state) => {
      return state.pending;
    },
    authToken: (state) => {
      return state.session.authToken;
    },
    refreshToken: (state) => {
      return state.refeshToken;
    },
    previousRoute: (state) => {
      return state.session.previousRoute;
    },
  },
  mutations: {
    AUTH_REQUEST(state: any) {
      state.pending = true;
    },
    AUTH_SUCCESS(state: any, data: any) {
      state.session.status = 'success';
      state.refeshToken = data.refreshToken;
      state.session.authToken = data.authToken;
      state.user = data._user;
      state.pending = false;
    },
    AUTH_ERROR(state: any) {
      state.session.status = 'error';
    },
    AUTH_LOGOUT(state: any) {
      state.user = null;
      state.refeshToken = '';
      state.session.authToken = '';
    },
    ROUTE_CHANGED(state: any, route: any) {
      state.session.previousRoute = route;
    },
  },
  actions: {
    INIT: ({commit, state}) => {
      return new Promise((res, reject) => {
        API.setAuthorizationHeader(state.session.authToken);
        res();
      });
    },
    AUTH_REQUEST: ({commit}, user) => {
      return new Promise((res, reject) => {
        commit('AUTH_REQUEST');
        API.signIn(user.username, user.password)
          .then((response) => {
            const refreshToken = response.data.refreshToken;
            const authToken = response.data.authToken;
            const _user = response.data.user;
            localStorage.setItem('refresh-token', refreshToken);
            localStorage.setItem('auth-token', authToken);
            localStorage.setItem('user', JSON.stringify(_user));
            API.setAuthorizationHeader(authToken);
            commit('AUTH_SUCCESS', {refreshToken, authToken, _user});
            res(response);
          })
          .catch((error) => {
            commit('AUTH_ERROR');
            localStorage.removeItem('refresh-token');
            localStorage.removeItem('auth-token');
            reject(error);
          });
      });
    },
    AUTH_REFRESH: ({commit, state}) => {
        return new Promise((res, reject) => {
          return API.refreshAuthToken(state.refeshToken)
            .then((response) => {
              const token = response.data.authToken;
              API.setAuthorizationHeader(token);
              state.session.authToken = token;
              res(response);
            }).catch((error) => {
              reject(error);
            });
        });
    },
    AUTH_LOGOUT: ({commit, dispatch}) => {
        return new Promise((res, reject) => {
          localStorage.clear();
          commit('AUTH_LOGOUT');
          res();
        });
    },
    ROUTE_CHANGED: ({commit, dispatch}, route) => {
      return new Promise((res, reject) => {
        commit('ROUTE_CHANGED', route);
        res();
      });
    },
  },
});
